export const ALL_GROUPS_OPTION = 'all_groups';

export const groupsFilterOptions = [ALL_GROUPS_OPTION];
